module.exports = __webpack_public_path__ + "static/media/Tenderlibrarybooks.6aac84ec.pdf";